<!--
    校区管理-分校管理
    功能：展示分校列表信息，编辑分校信息
-->
<template>
  <div class="branch_school">
    <AppList
      ref="list"
      :list.sync="list"
      :create-label="$permissions('school_admin_branch_apply') ? '申请分校' : ''"
      title=""
      :api="api"
      :api-type="api"
      @create="toCreate"
    >
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            width="80px"
            label="头像">
            <template slot-scope="scope">
              <img
                class="head_url"
                :src="scope.row.review_last ? scope.row.review_last.logo : ''"
                alt="">
            </template>
          </el-table-column>
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
<!--          <el-table-column-->
<!--            label="是否禁用"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.is_allow_teaching=='Y'">启用</span>-->
<!--              <span v-else>禁用</span>-->
<!--              <el-switch-->
<!--                :value="scope.row.is_allow_teaching=='Y'"-->
<!--                active-color="#13ce66"-->
<!--                inactive-color="#e3e3e3"-->
<!--                @change="switchStatus(scope.row)"/>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            label="操作"
            width="220px"
            class="orgin-btn">
            <template slot-scope="scope">
              <template v-if="scope.row.status_review !== 'submit' && $permissions('school_admin_branch_edit')">
                <el-link
                  @click="edit(scope.row)"
                >编辑</el-link>
              </template>
<!--              <el-button-->
<!--                size="small"-->
<!--                @click="setPrice(scope.row)"-->
<!--              >账户</el-button>-->
<!--              <el-dropdown trigger="hover">-->
<!--              <span class="el-dropdown-link">-->
<!--                更多<i class="el-icon-caret-bottom el-icon&#45;&#45;right"/>-->
<!--              </span>-->
<!--                <el-dropdown-menu slot="dropdown">-->
<!--&lt;!&ndash;                  <el-dropdown-item&ndash;&gt;-->
<!--&lt;!&ndash;                    class="clearfix">&ndash;&gt;-->
<!--&lt;!&ndash;                  <span&ndash;&gt;-->
<!--&lt;!&ndash;                    class="dropdownSpan"&ndash;&gt;-->
<!--&lt;!&ndash;                    @click="authCourseware(scope.row.id)">课件授权</span>&ndash;&gt;-->
<!--&lt;!&ndash;                  </el-dropdown-item>&ndash;&gt;-->
<!--                  <el-dropdown-item-->
<!--                    class="clearfix">-->
<!--                  <span-->
<!--                    class="dropdownSpan"-->
<!--                    @click="wxDispose(scope.row.id, scope.row.name)">统计数据</span>-->
<!--                  </el-dropdown-item>-->
<!--                </el-dropdown-menu>-->
<!--              </el-dropdown>-->
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
  </div>
</template>

<script>
  import list from '@/mixins/list';
  import baseUrl from "../../utils/api";
  export default {
    name: "BranchSchool",
    inject: ['reload'],
    mixins: [list],
    data() {
      return {
        list: {},
        baseUrl: baseUrl
      }
    },
    computed: {
      api () {
        return `${baseUrl}/api/clients?clients_id=` + (localStorage.getItem('school_id') || this.$store.state.choicesSchool.id);
      },
      columns() {
        return [
          { prop: 'review_last.name', label: '校区名称' },
          { prop: 'review_last.user_name', label: '分校长' },
          { prop: 'review_last.user_mobile', label: '联系电话' },
          { prop: 'review_last.category.name', label: '所属类别' },
          {
            label: '区域',
            formatter: (row) => {
              return row.review_last ? `${row.review_last.province || ''} ${row.review_last.city || ''} ${row.review_last.area || ''} ${row.review_last.street || ''}` : ''
            }
          },
          {
            label: '审核状态',
            formatter: (row) => {
              const obj = {
                'submit': '正在审核',
                'adopt': '审核通过',
                'reject': '审核失败'
              };
              return row.review_last ? obj[row.review_last.status_review] : ''
            }
          },
          { prop: 'review_last.name4', label: '授权课件数' },
          { prop: 'review_last.name5', label: '有效期', width: '160px' },
        ];
      },
      searchArr() {
        const column = [
          { prop: 'review_school_name', label: '校区名称' },
          { prop: 'review_school_user_name', label: '分校长' },
          { prop: 'review_school_user_mobile', label: '手机号' }
        ];
        return [
          {
            selectValue: [
              { value: 'submit', name: '审核中' },
              { value: 'adopt', name: '审核通过' },
              { value: 'reject', name: '审核失败' }
            ],
            componentType: 'AppSearchStatusString',
            searchType: 'review_school_status',
            placeholder: '请选择审核状态'
          },
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      },
      role() {
        return this.$store.state.user;
      },
    },
    methods: {
      // 申请分校
      toCreate() {
        this.$router.push('/branchSchool/apply')
      },
      // 课件授权按钮
      authCourseware(id) {
        this.$router.push(`/branchSchool/courseware/${id}`)
      },
      // 编辑
      edit(row) {
        this.$router.push(`/branchSchool/edit/${row.id}`)
      }
    }
  }
</script>

<style scoped lang="scss">
.branch_school {
  .head_url {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BranchSchool/index.vue